<template>
  <div>
    <div class="page-title">Edit Review</div>
    <Form v-if="form" v-model="form" :submit="update" btnText="Update Review" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.profile_reviews.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.ProfileReview.update(this.form);
      this.$router.push(`/users/participants/${this.form.user_id}?tab=2`);
    },
    async setForm() {
      const { data } = await this.$api.ProfileReview.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
